import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { getTrans as t } from "../../Localization/translations";
import ButtonLoading from '../../components/Loder/buttonLoading';
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import ACHproviderService from "../../services/ACHproviders/ACHproviderServices";

const EditAchProvider = () => {
  const checkBtn = useRef();
  const form = useRef();
  const navigate = useNavigate();
  // If using location
  const { state } = useLocation();
  console.log("Edit page, id from state:", state);

  // If using params
  const { id } = useParams();
  console.log("Edit page, id from params:", id);

  // react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // Form fields state
  const [achprovider, setAchprovider] = useState({
    immediate_destination: "",
    immediate_destination_name: "",
    immediate_origin: "",
    immediate_origin_name: "",
    company_identification: "",
    standard_entry_class_code: "",
    originating_bank_fid: "",
    originator_tax_id: "",
    ach_operator_name: "",
    destination: "",
    destination_name: "",
    service_class_code: "",
  });
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);

  // Fetch single ACH provider by id
  useEffect(() => {
    setLoading(true);
    ACHproviderService.getACHprovider(state)
      .then((response) => {
        console.log("response ",response)
        // Use your API response shape here!
        const data = response.response;
        setAchprovider({
          immediate_destination: data.immediate_destination || "",
          immediate_destination_name: data.immediate_destination_name || "",
          immediate_origin: data.immediate_origin || "",
          immediate_origin_name: data.immediate_origin_name || "",
          company_identification: data.company_identification || "",
          standard_entry_class_code: data.standard_entry_class_code || "",
          originating_bank_fid: data.originating_bank_fid || "",
          originator_tax_id: data.originator_tax_id || "",
          ach_operator_name: data.ach_operator_name || "",
          destination: data.destination || "",
          destination_name: data.destination_name || "",
          service_class_code: data.service_class_code || "",
        });
        reset({
          immediate_destination: data.immediate_destination || "",
          immediate_destination_name: data.immediate_destination_name || "",
          immediate_origin: data.immediate_origin || "",
          immediate_origin_name: data.immediate_origin_name || "",
          company_identification: data.company_identification || "",
          standard_entry_class_code: data.standard_entry_class_code || "",
          originating_bank_fid: data.originating_bank_fid || "",
          originator_tax_id: data.originator_tax_id || "",
          ach_operator_name: data.ach_operator_name || "",
          destination: data.destination || "",
          destination_name: data.destination_name || "",
          service_class_code: data.service_class_code || "",
        });
      })
      .catch(() => {
        toast.error(t("Failed to fetch ACH Provider data"));
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, [state, reset]);

  const achChange = (e) => {
    const { name, value } = e.target;
    setAchprovider(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handelClick = () => {
    navigate("/achproviders");
  };

  const handleRegister = () => {
  setLoading(true);
  setDisable(true);

  ACHproviderService.editachprovider(state, achprovider)
    .then(response => {
      if (response.data && response.data.success) {
        setLoading(false);
        setTimeout(() => {
          setDisable(false);
          navigate("/achproviders");
        }, 2000);
        toast.success(`${response.data.response || t("ACH Provider updated successfully!")}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(`${response.data.error || t("Failed to update ACH Provider!")}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        setDisable(false);
      }
    })
    .catch(() => {
      toast.error(t("Failed to update ACH Provider!"));
      setLoading(false);
      setDisable(false);
    });
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="header pb-0 mb-3 pt-3">
          <h5>{t("Edit ACH Provider")}</h5>
          <h6>
            <Link to="/achproviders" className="tc">
              {t("ACH Providers")}
            </Link>{" "}
            / <span>{t("Edit ACH Provider")}</span>
          </h6>
          <div className="show_invoice">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {loading ? (
                      <div className="text-center py-4"><ButtonLoading /></div>
                    ) : (
                      <Form
                        role="form text-left"
                        onSubmit={handleSubmit(handleRegister)}
                        ref={form}
                        action="."
                        method="POST"
                      >
                        <>
                        <div className="row">
                          <div className="">
                            <div className="col-lg-12">

                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Destination")}&nbsp;
                                    <Tooltip content={t("immediate_destination_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_destination}
                                    className={`form-control${errors.immediate_destination ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="immediate_destination"
                                    id="immediate_destination"
                                    {...register("immediate_destination", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_destination ? "block" : "none" }}>
                                    {errors.immediate_destination?.type === "required" && "Immediate Destination is required"}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Destination Name")}&nbsp;
                                    <Tooltip content={t("Immediatedestname_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_destination_name}
                                    className={`form-control${errors.immediate_destination_name ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="immediate_destination_name"
                                    id="immediate_destination_name"
                                    {...register("immediate_destination_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_destination_name ? "block" : "none" }}>
                                    {errors.immediate_destination_name?.type === "required" && "Immediate Destination Name is required"}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Origin")}&nbsp;
                                    <Tooltip content={t("immediate_origin_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_origin}
                                    className={`form-control${errors.immediate_origin ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="immediate_origin"
                                    id="immediate_origin"
                                    {...register("immediate_origin", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_origin ? "block" : "none" }}>
                                    {errors.immediate_origin?.type === "required" && "Immediate Origin is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Origin Name")}&nbsp;
                                    <Tooltip content={t("immediate_origin_name_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_origin_name}
                                    className={`form-control${errors.immediate_origin_name ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="immediate_origin_name"
                                    id="immediate_origin_name"
                                    {...register("immediate_origin_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_origin_name ? "block" : "none" }}>
                                    {errors.immediate_origin_name?.type === "required" && "Immediate Origin Name is required"}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Company Identification")}&nbsp;
                                    <Tooltip content={t("CompanyIdentification_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.company_identification}
                                    className={`form-control${errors.company_identification ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="company_identification"
                                    id="company_identification"
                                    {...register("company_identification", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.company_identification ? "block" : "none" }}>
                                    {errors.company_identification?.type === "required" && "Company Identification is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Standard Entry Class Code")}&nbsp;
                                    <Tooltip content={t("StandardEntryClassCode_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.standard_entry_class_code}
                                    className={`form-control${errors.standard_entry_class_code ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="standard_entry_class_code"
                                    id="standard_entry_class_code"
                                    {...register("standard_entry_class_code", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.standard_entry_class_code ? "block" : "none" }}>
                                    {errors.standard_entry_class_code?.type === "required" && "Standard Entry Class Code is required"}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Originating BANK FID")}&nbsp;
                                    <Tooltip content={t("OriginatingBankFID_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.originating_bank_fid}
                                    className={`form-control${errors.originating_bank_fid ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="originating_bank_fid"
                                    id="originating_bank_fid"
                                    {...register("originating_bank_fid", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.originating_bank_fid ? "block" : "none" }}>
                                    {errors.originating_bank_fid?.type === "required" && "Originating BANK FID is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Originator Tax ID")}&nbsp;
                                    <Tooltip content={t("OriginatorTaxID_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.originator_tax_id}
                                    className={`form-control${errors.originator_tax_id ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="originator_tax_id"
                                    id="originator_tax_id"
                                    {...register("originator_tax_id", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.originator_tax_id ? "block" : "none" }}>
                                    {errors.originator_tax_id?.type === "required" && "Originator Tax ID is required"}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("ACH Operator Name")}&nbsp;
                                    <Tooltip content={t("ACHOperatorname_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.ach_operator_name}
                                    className={`form-control${errors.ach_operator_name ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="ach_operator_name"
                                    id="ach_operator_name"
                                    {...register("ach_operator_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.ach_operator_name ? "block" : "none" }}>
                                    {errors.ach_operator_name?.type === "required" && "ACH Operator Name is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Destination")}&nbsp;
                                    <Tooltip content={t("Destination_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.destination}
                                    className={`form-control${errors.destination ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="destination"
                                    id="destination"
                                    {...register("destination", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.destination ? "block" : "none" }}>
                                    {errors.destination?.type === "required" && "Destination is required"}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Destination Name")}&nbsp;
                                    <Tooltip content={t("DestinationName_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.destination_name}
                                    className={`form-control${errors.destination_name ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="destination_name"
                                    id="destination_name"
                                    {...register("destination_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.destination_name ? "block" : "none" }}>
                                    {errors.destination_name?.type === "required" && "Destination Name is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Service Class Code")}&nbsp;
                                    <Tooltip content={t("ServiceClassCode_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.service_class_code}
                                    className={`form-control${errors.service_class_code ? " is-invalid" : ""}`}
                                    type="text"
                                    onChange={achChange}
                                    name="service_class_code"
                                    id="service_class_code"
                                    {...register("service_class_code", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.service_class_code ? "block" : "none" }}>
                                    {errors.service_class_code?.type === "required" && "Service Class Code is required"}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="text-left py-3">
                          <button
                            type="button"
                            onClick={handelClick}
                            className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                            disabled={disable}
                          >
                            {t("Cancel")}
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="submit"
                            className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                            disabled={disable}
                          >
                            {loading === false ? t("Update") : <ButtonLoading />}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                        </>
                      </Form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAchProvider;

